<div class="sidebar included">
	<app-sidebar-header [title]="INDRA_getGroupLabel()"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<app-flight-route [flight]="flight"></app-flight-route>
		<div class="sidebar-flight-text">
			<h2 class="title-h2">{{'whatsIncludedSidebars.detailsSnacks.titles.includedPassenger' | ibeadmin:'sync'}}</h2>
			<!-- START UNCONFIRMED ANCILLARIES WARNING /-->
			<ng-container *ngFor="let statusCode of ancillaryCartService.INDRA_getAllWarnings(flight.idFlight.toString(), ancillaryGroup)">
				<app-notification [style]="'alert'" [close]="true" [icon]="'icons.svg#airport--delays'" [classes]="'alert-sidebar top-gap bottom-gap'"
				 [title]=" INDRA_getGroupLabel() + ' ' + ('whatsIncludedSidebars.general.texts.is' | ibeadmin:'sync')
				 + ' ' + (ancillaryCartService.INDRA_getStatusKey(statusCode)| ibeadmin:'sync') + ' ' + ('whatsIncludedSidebars.general.texts.inThisFlight' | ibeadmin:'sync')">
					<div message><span *ngIf="statusCode !== 46">{{'whatsIncludedSidebars.general.texts.useInAnotherFlight' | ibeadmin:'sync'}}</span>
						<a class="link" href="{{'whatsIncludedSidebars.general.texts.contactLink' | ibeadmin:'sync'}}" target="_blank" aria-label="Go to refunds page">
							{{'whatsIncludedSidebars.general.texts.contactTap' | ibeadmin:'sync'}}
						</a>
						{{'whatsIncludedSidebars.general.texts.moreInfo' | ibeadmin:'sync'}}
					</div>
				</app-notification>
			</ng-container>
			<!-- END UNCONFIRMED ANCILLARIES WARNING -->
			<div *ngFor="let passenger of passengers" class="border sidebar-flight-text ">
				<div *ngIf="INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length > 0" class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding">
						<p class="bold">{{INDRA_printPassengerName(passenger)}}</p>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p class="">
							<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true" [alt]="'Checked icon'">
							</app-svg>
							<span class="bold">{{INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax)}}</span>
							{{'whatsIncludedSidebars.detailsSnacks.texts.includedIn' | ibeadmin:'sync'}} 
							<span class="capitalize">{{INDRA_printBrand()}}</span>.
						</p>
					</div>
				</div>
				<!-- purchased ancillaries for the passenger-->
				<div *ngFor="let item of INDRA_getPurchasedAncillaryForPassenger(passenger.idPax); let i = index;" class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding">
						<p *ngIf="i == 0 && INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length == 0"
						 class="bold">{{INDRA_printPassengerName(passenger)}}</p>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p class="">
							<!-- START UNCONFIRMED ANCILLARIES WARNING -->
							<ng-container *ngIf="!item.unconfirmed">
								<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true"></app-svg>
							</ng-container>
							<ng-container *ngIf="item.unconfirmed">
								<app-svg class="list--checked__icon" svg="sprite.svg#status--alert" aria-hidden="true"></app-svg>
							</ng-container>
							<!-- END UNCONFIRMED ANCILLARIES WARNING -->
							<span class="bold">{{item.ancillaryDetail}}</span><span *ngIf="hasLayover">{{INDRA_displaySegmentInfo(item.segmentId)}}</span>
						</p>
					</div>
				</div>
				<!-- no ancillaries for the passenger-->
				<div *ngIf="INDRA_getPurchasedAncillaryForPassenger(passenger.idPax).length == 0 && INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length == 0"
				 class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding">
						<p class="bold">{{INDRA_printPassengerName(passenger)}}</p>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p class="">{{'whatsIncludedSidebars.detailsSnacks.texts.notIncluded' | ibeadmin:'sync'}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="sidebar-flight-text" *ngIf="hasInfant">
			<h2 class="title-h2">{{'whatsIncludedSidebars.detailsSnacks.titles.babyFood' | ibeadmin:'sync'}}</h2>
			<p class="muted">{{'whatsIncludedSidebars.detailsSnacks.texts.babyFood' | ibeadmin:'sync'}}</p>
			<a (click)="INDRA_gotoURL('externalURLs.aboutMealsForBabies')" href="javascript:;" class="link extras-feature__link link--external"
			  [attr.aria-label]="'whatsIncludedSidebars.detailsSnacks.aria.openDialogAboutBabyMeals' | ibeadmin:'sync'">{{'whatsIncludedSidebars.detailsSnacks.texts.allAboutBabyMeals'
				| ibeadmin:'sync'}}</a>
		</div>
		
		<div class="sidebar-flight-text" *ngIf="INDRA_showSpecialMeals() && showAddButton">
			<h2 class="title-h2">
				{{'whatsIncludedSidebars.detailsSnacks.titles.preorderMeal' | ibeadmin:'sync'}}
			</h2>
			<p class="muted">
				{{'whatsIncludedSidebars.detailsSnacks.texts.mainCoursePreorder' | ibeadmin:'sync'}}
			</p>
			<button class="button " (click)="openMealSidebar()" 
				*ngIf="!isBookingView && _hasEdit && !INDRA_checkIfCodeShare()" 
				[attr.aria-label]="'whatsIncludedSidebars.detailsSnacks.aria.openDialogSpecialMeal' | ibeadmin:'sync'">
				{{'whatsIncludedSidebars.detailsSnacks.button.selectMainCourse' | ibeadmin:'sync'}}
			</button>
		</div>
		<!--
		<div class="sidebar-flight-text" *ngIf="TAP_getFlightDuration()>4">
			<p class="muted">if any the passagers has a food restriction or if you wish to request a child meal, please
				do so
				before boarding. Special meals are free of charge.</p>
			<button class="button " (click)="TAP_handleClose()" *ngIf="_hasEdit && isMYB"
				aria-label="Open a dialog to Upgrade to Executive.">Upgrade to Executive</button>
		</div>
		-->
		<div class="sidebar-flight-text" *ngIf="INDRA_showUpgrade()">
			<p class="muted">{{'whatsIncludedSidebars.detailsSnacks.texts.specialMeals' | ibeadmin:'sync'}}</p>
			<button class="button " (click)="INDRA_upgradeWithCash()" *ngIf="!isBookingView && INDRA_showUpgrade()" [attr.aria-label]="'whatsIncludedSidebars.detailsSnacks.aria.openDialogUpgrade' | ibeadmin:'sync'">{{'whatsIncludedSidebars.detailsSnacks.button.upgradeToExecutive'
				| ibeadmin:'sync'}}</button>
		</div>
		<div class="sidebar-flight-text border">
			<p>
				<a class="link extras-feature__link" aria-label="Close dialog" (click)="INDRA_handleClose()" href="javascript:;" role="button">
					{{ 'whatsIncludedSidebars.detailsSnacks.texts.closeWindow' | ibeadmin: 'sync' }}
				</a>
			</p>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer "></div>
</div>
